import { render, staticRenderFns } from "./KnowledgeWindow.vue?vue&type=template&id=83bf5244&"
import script from "./KnowledgeWindow.vue?vue&type=script&lang=js&"
export * from "./KnowledgeWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports